import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin-bottom: 50px;
`;

export const BlogList = styled.div`
  display: grid;

  gap: 20px;

  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    grid-template-columns: repeat(3, 1fr);
    gap: 32px 20px;
    margin-bottom: 40px;
  }
`;
